<template>
  <div ref="messageList" class="viq-msg-list">
    <div v-if="messagesLoading" class="viq-msg-list__loading">
      <ViqMessageLoading />
    </div>
    <template v-else>
      <template v-for="(msg, i) in sortedMessages">
        <ViqMessageUser
          v-if="msg.role === 'user'"
          :key="msg.id || i"
          :message="msg"
        />
        <ViqMessageAssistant
          v-else-if="msg.role === 'assistant'"
          :key="msg.id || ('a' + i)"
          :message="msg"
          :is-last="i === sortedMessages.length - 1"
          :is-streaming="isStreaming && i === sortedMessages.length - 1"
        />
      </template>
      <ViqMessageLoading v-if="isStreaming && sortedMessages.length === 0" />
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "ViqMessageList",
  components: {
    ViqMessageLoading: () => import("./ViqMessageLoading"),
    ViqMessageUser: () => import("./ViqMessageUser"),
    ViqMessageAssistant: () => import("./ViqMessageAssistant"),
  },
  computed: {
    ...mapState("Viq", ["messagesLoading", "isStreaming"]),
    ...mapGetters("Viq", ["sortedMessages"]),
  },
  watch: {
    sortedMessages: {
      deep: true,
      handler() {
        this.$nextTick(() => this.scrollToBottom());
      },
    },
    isStreaming(val) {
      if (val) {
        this.$nextTick(() => this.scrollToBottom());
      }
    },
  },
  mounted() {
    this.scrollToBottom();
  },
  methods: {
    scrollToBottom() {
      const el = this.$refs.messageList;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-msg-list {
  flex: 1;
  overflow-y: auto;
  padding: $viq-space-md 0;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
  }

  &__loading {
    display: flex;
    justify-content: center;
    padding: $viq-space-xl;
  }
}
</style>
